import React from "react";
import PropTypes from "prop-types";
import styles from "components/grid/cell-formatters/name-cell-formatter.scss";

export const NameCellFormatter = ({ value }) => {
  if (!value || value === "No Name") {
    return <span className={ styles["no-name"] }>No Name</span>;
  }
  return <span>{ value }</span>;
};

NameCellFormatter.propTypes = {
  value: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./src/js/components/grid/cell-formatters/name-cell-formatter.jsx